import styled from 'styled-components';
import indents from '@bankiru/ui-kit/constants/indents.json';

export const StyledHeaderWrapper = styled.header`
	padding-top: ${({ isMobile }) => (isMobile ? indents.indent12 : indents.indentM)};
	padding-bottom: ${({ isMobile }) => (isMobile ? indents.indent12 : indents.indentM)};
`;
